import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import CaseStudy from '../../../micro/caseStudy/CaseStudy';
import { BASE_URL, IMAGE_PATHS } from '../../../../constants/paths.constants';
import { universalStyles } from '../../../../app/theme';

const useStyles = makeStyles(() => ({
  ...universalStyles,
  headerImage: {
    display: 'block',
    width: '100%',
  },
  header: {
    marginTop: 30,
  },
  image: {
    paddingTop: 10,
    paddingBottom: 20,
    width: '80%',
    marginLeft: '10%',
  },
}));

type InterpretationPage11Props = {
  setNextDisabledCS: (disabled: boolean) => void;
};

const InterpretationPage11 = ({ setNextDisabledCS }: InterpretationPage11Props): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.grayBox}>
        <img
          className={classes.headerImage}
          src={`${BASE_URL}${IMAGE_PATHS.STEPS[1].INTERPRETATION_STEP_2.path}`}
          alt={`${IMAGE_PATHS.STEPS[1].INTERPRETATION_STEP_2.alt}`}
        />
        <div className={classes.whiteBox}>
          <Typography variant="h2">STEP 2:</Typography>
          <Typography variant="h3">Review PET Window Display Guidelines</Typography>
          <Typography variant="h5" className={classes.header}>
            To ensure that all organs are being reviewed appropriately, the following PET window display guidelines are
            suggested
          </Typography>
          <img
            className={classes.image}
            src={`${BASE_URL}${IMAGE_PATHS.PET_WINDOW_DISPLAY_GUIDELINES.path}`}
            alt={`${IMAGE_PATHS.PET_WINDOW_DISPLAY_GUIDELINES.alt}`}
          />
          <ul className={classes.list}>
            <li>
              The most appropriate windowing is typically scanner/workstation dependent and must be selected based
              clinical judgment and experience of the reader
            </li>
          </ul>
          <Typography variant="h5" className={classes.header}>
            Post-Prostatectomy
          </Typography>
          <CaseStudy trainingId={1} module="axuminInterpretation" page={11} setNextDisabledCS={setNextDisabledCS} />
        </div>
      </div>
    </>
  );
};

export default InterpretationPage11;
